import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './MfproductAPI';
import {getColumns} from './MfproductStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getMfproductView} from './MfproductView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteMfproductObj  ,setSelectedMfproductId,setMfproductAttachImageModal,setMfproductManageProductModal,setMfproductLinkAssetModal,setMfproductManageAssetsModal,setMfproductAssetViewerModal,setMfproductSendWhatisupMsgModal,setSelectedActionId , setShowEditForMfproduct} from 'store/slice/ManufSlice';

import MfproductListTable from './components/MfproductListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import MfproductFilterCriteria from './MfproductFilterCriteria';


import ImageIcon from '@mui/icons-material/Image';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import GridViewIcon from '@mui/icons-material/GridView';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import AttachImageActionModal from './action/attachImage/AttachImageActionModal';
import ManageProductActionModal from './action/ManageProduct/ManageProductActionModal';
import LinkAssetActionModal from './action/LinkAsset/LinkAssetActionModal';
import ManageAssetsActionModal from './action/ManageAssets/ManageAssetsActionModal';
import AssetViewerActionModal from './action/AssetViewer/AssetViewerActionModal';
import SendWhatisupMsgActionModal from './action/SendWhatisupMsg/SendWhatisupMsgActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function MfproductList( {tableList, cardList, setShowEdit, setMfproductId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, mfproductObj} = useSelector((state)=>state.manufslice.mfproductDashboard);
  const { mfproductList } = useSelector((state) => state.manufslice.mfproductDashboard);

  useEffect(() => {
  }, [mfproductList, mfproductObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedMfproductId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteMfproductObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedMfproductId(id));
    dispatch(setShowEditForMfproduct(true));
  }
  
  const createMfproduct=()=>{
    dispatch(setSelectedMfproductId(-1));
    dispatch(setShowEditForMfproduct(true));
  }


  const attachImageCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductAttachImageModal(true));
  }
  const ManageProductCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductManageProductModal(true));
  }
  const LinkAssetCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductLinkAssetModal(true));
  }
  const ManageAssetsCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductManageAssetsModal(true));
  }
  const AssetViewerCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductAssetViewerModal(true));
  }
  const SendWhatisupMsgCallBack = (id) =>{
    dispatch(setSelectedMfproductId(id));
    dispatch(setMfproductSendWhatisupMsgModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const mfproductTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    mfproductList:mfproductList,
    cardList:getMfproductView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:82, title:'Attach Image', callBackMethod:attachImageCallBack, icon:<ImageIcon/>, status:'NA', role:'FACTORY_MANAGER'},
        {id:83, title:'Manage Product1', callBackMethod:ManageProductCallBack, icon:<BorderColorIcon/>, status:'NA', role:'FACTORY_MANAGER'},
        {id:100, title:'Link Asset', callBackMethod:LinkAssetCallBack, icon:<AddPhotoAlternateIcon/>, status:'Draft', role:''},
        {id:101, title:'Manage Assets', callBackMethod:ManageAssetsCallBack, icon:<InsertPhotoIcon/>, status:'Draft', role:''},
        {id:102, title:'AssetViewer', callBackMethod:AssetViewerCallBack, icon:<GridViewIcon/>, status:'Draft', role:''},
        {id:110, title:'Send Whatisup Message', callBackMethod:SendWhatisupMsgCallBack, icon:<WhatsAppIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:mfproductTransformation(tableList),
      mfproductList:mfproductList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:82, title:'Attach Image', callBackMethod:attachImageCallBack, icon:<ImageIcon/>, status:'NA', role:'FACTORY_MANAGER'},
        {id:83, title:'Manage Product1', callBackMethod:ManageProductCallBack, icon:<BorderColorIcon/>, status:'NA', role:'FACTORY_MANAGER'},
        {id:100, title:'Link Asset', callBackMethod:LinkAssetCallBack, icon:<AddPhotoAlternateIcon/>, status:'Draft', role:''},
        {id:101, title:'Manage Assets', callBackMethod:ManageAssetsCallBack, icon:<InsertPhotoIcon/>, status:'Draft', role:''},
        {id:102, title:'AssetViewer', callBackMethod:AssetViewerCallBack, icon:<GridViewIcon/>, status:'Draft', role:''},
        {id:110, title:'Send Whatisup Message', callBackMethod:SendWhatisupMsgCallBack, icon:<WhatsAppIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">MF Product</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < MfproductFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Mfproduct" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createMfproduct()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < MfproductListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<AttachImageActionModal/>
<ManageProductActionModal/>
<LinkAssetActionModal/>
<ManageAssetsActionModal/>
<AssetViewerActionModal/>
<SendWhatisupMsgActionModal/>
    </>
);


}